import { inject, makeStateKey, TransferState } from "@angular/core";
import { ResolveFn } from "@angular/router";
import { TServiceResult } from "@shared/helper/t-service-result";
import { IClubPollAggregateModel } from "@app/pages/clubs/models/club-poll-aggregateModel";
import { of, switchMap } from "rxjs";
import { LocalRepository } from "@shared/helper/local-repository";

import { ClubAggregatorService } from "@app/pages/clubs/services/club-aggregator.service";

export const STATE_KEY_POLL_DETAIL = makeStateKey<TServiceResult<IClubPollAggregateModel>>("STATE_KEY_POLL_DETAIL");


export const PollDetailResolver: ResolveFn<TServiceResult<IClubPollAggregateModel>> = (route, state) => {
  const _localRepository: LocalRepository = inject(LocalRepository);
  const serverState: TransferState = inject(TransferState);
  const clubAggregatorService: ClubAggregatorService = inject(ClubAggregatorService);
  if (!_localRepository.IsInBrowser) {
    return clubAggregatorService.getPollById(route.paramMap.get('id')!)
      .pipe(switchMap(res => {
        serverState.set(STATE_KEY_POLL_DETAIL, res);
        return of(res);
      }));
  }

  return of(serverState.get(STATE_KEY_POLL_DETAIL, TServiceResult.fromFailure<any>(null)));
}
